// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const BoltIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 23 30" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M14.9921 1.875L13.1171 13.125H20.6171L7.49213 28.125L9.36713 16.875H1.86713L14.9921 1.875ZM14.9921 0C14.4648 0 13.9492 0.222656 13.5859 0.644531L0.460876 15.6445C-0.0195925 16.1953 -0.13678 16.9805 0.167908 17.6484C0.460876 18.3164 1.12884 18.75 1.86713 18.75H7.15228L5.64056 27.8203C5.49994 28.6523 5.93353 29.4609 6.68353 29.8242C6.94134 29.9414 7.21088 30 7.48041 30C8.00775 30 8.52338 29.7773 8.88666 29.3555L22.0117 14.3555C22.4921 13.8047 22.6093 13.0195 22.3046 12.3516C22.0234 11.6836 21.3554 11.25 20.6171 11.25H15.332L16.8437 2.17969C16.9843 1.34766 16.5507 0.539062 15.8007 0.175781C15.5429 0.0585938 15.2617 0 14.9921 0Z" />
        </svg>
      )
    }
  </Icon>
);

export default BoltIcon;
